import React, {useEffect} from 'react'
import {useNavigate} from 'react-router-dom'

import {useAppSelector} from '../../../../../../../../hooks/react-redux'
import {DisabledContext} from '../../../../../contexts/DisabledContext'
import {
  useIsJobDeleted,
  useJobId,
  usePipelineJobIdsOrDraft,
} from '../../../../../EditPipelinePage/EditPipelinePage.hooks'
import {getDraft} from '../../../../../EditPipelinePage/EditPipelinePage.selectors'
import type {pipelineHeadFragment$key} from '../../../../../hooks/__generated__/pipelineHeadFragment.graphql'
import {usePipelineId} from '../../../../../hooks/pipeline'

import JobAgentRequirements from './JobAgentRequirements/JobAgentRequirements'
import JobCheckoutWorkingDirectoriesOnly from './JobCheckoutWorkingDirectoriesOnly/JobCheckoutWorkingDirectoriesOnly'
import JobDependencies from './JobDependencies/JobDependencies'
import JobFilesPublication from './JobFilesPublication/JobFilesPublication'
import JobIntegrations from './JobIntegrations/JobIntegrations'
import JobName from './JobName/JobName'
import JobParallelism from './JobParallelism/JobParallelism'
import JobSettingsFooter from './JobSettingsFooter/JobSettingsFooter'
import JobSettingsOverlay from './JobSettingsOverlay/JobSettingsOverlay'
import JobSteps from './JobSteps/JobSteps'

type Props = {pipelineHeadKey: pipelineHeadFragment$key | null}
export default function JobSettingsSidebar({pipelineHeadKey}: Props) {
  const id = useJobId()!

  const jobIds = usePipelineJobIdsOrDraft()
  const pipelineId = usePipelineId()
  const isLoaded = useAppSelector(state => getDraft(state, pipelineId) != null)
  const navigate = useNavigate()
  const isNotFound = isLoaded && !jobIds.includes(id)
  useEffect(() => {
    if (isNotFound) {
      navigate({search: ''}, {replace: true})
    }
  }, [isNotFound, navigate])
  const isDeleted = useIsJobDeleted(id)

  return (
    <DisabledContext.Provider value={isDeleted}>
      <JobName jobId={id} />
      <JobDependencies jobId={id} />
      <JobSteps jobId={id} pipelineHeadKey={pipelineHeadKey} />
      <JobCheckoutWorkingDirectoriesOnly jobId={id} />
      <JobAgentRequirements jobId={id} />
      <JobFilesPublication jobId={id} />
      <JobParallelism />
      <JobIntegrations />
      <JobSettingsOverlay jobId={id} />
      <JobSettingsFooter jobId={id} />
    </DisabledContext.Provider>
  )
}
